var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDataPiplineArchitectureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3563_989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.345 18.3331L3.54 38.3331H1.66667V7.4998C1.66667 6.12146 2.78833 4.9998 4.16667 4.9998H9.80333L16.47 8.33313H18.3333V6.66646H16.8633L10.1967 3.33313H4.16667C1.86833 3.33313 0 5.20313 0 7.4998V39.9998H33.2167L40 18.3331H9.345ZM31.9917 38.3331H5.27667L10.5983 19.9998H37.73L31.9917 38.3331ZM23.3167 13.2348C24.9417 13.9398 27.4317 14.1665 29.1683 14.1665C30.8917 14.1665 33.3533 13.9415 34.98 13.2498L34.9767 15.0415L36.6433 15.0448L36.6683 2.91813C36.6683 0.616465 31.955 0.00146484 29.17 0.00146484C26.385 0.00146484 21.6733 0.616465 21.6717 2.91646L21.6467 15.0431L23.3133 15.0465L23.3167 13.2348ZM23.32 11.3881V11.3098C23.3267 11.3231 23.3367 11.3465 23.3367 11.3881H23.32ZM23.3333 4.86146C24.96 5.5948 27.4367 5.83313 29.1683 5.83313C30.9 5.83313 33.37 5.5948 34.9967 4.8648L34.9917 7.15813C34.715 7.5248 32.7617 8.33313 29.1683 8.33313C25.5267 8.33313 23.5617 7.4998 23.3283 7.14146L23.3333 4.86146ZM23.3283 7.18146C23.3317 7.19647 23.3367 7.1998 23.3367 7.22147H23.3283V7.18146ZM29.1683 12.4998C25.5017 12.4998 23.5317 11.6548 23.32 11.2998L23.325 9.0698C24.9517 9.77146 27.4333 9.99813 29.1683 9.99813C30.9033 9.99813 33.3617 9.77146 34.9883 9.07813L34.9833 11.3315C34.6867 11.7015 32.7367 12.4998 29.1683 12.4998ZM29.1683 1.66646C32.86 1.66646 34.8417 2.59646 35.0083 2.86813C34.8417 3.23813 32.86 4.16646 29.1683 4.16646C25.63 4.16646 23.6633 3.31313 23.36 2.91646C23.665 2.5198 25.63 1.66646 29.1683 1.66646Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3563_989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPiplineArchitectureIcon);
export default __webpack_public_path__ + "static/media/data_pipline-architecture-icon.beb0668cd7a71cd656de18cf4ebf33e1.svg";
export { ForwardRef as ReactComponent };